exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._28iq2FiyUY-5x65i0o5mAo{width:100%;height:100%;margin:5px auto;border:1px solid #ccc;text-align:center;padding:5px}", ""]);

// exports
exports.locals = {
	"pic": "_28iq2FiyUY-5x65i0o5mAo"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/rt-sd-comp/sgiComp/SgiImg.css
// module id = 1608
// module chunks = 1